import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: 'https://cheguanapi.zhonganchuangxin.cn' ,
  timeout: 10000
})

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 401) {
        Message.error('登录已过期')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        window.location.href = '#/login'
        return Promise.reject(new Error(res.msg))
      }
      Message.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    if (error.response?.status === 401) {
      Message.error('登录已过期')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      window.location.href = '#/login'
    } else {
      Message.error(error.message || '网络错误')
    }
    return Promise.reject(error)
  }
)

export default service